import { useState } from "react";

function ButtonTabBar(props) {
  const {
    tabsCount,
    onClick = null,
    tabsList,
    tabIdKey,
    showCountOnlyOnActiveTab = false,
    badgePosition = "end",
    tabBarBgColor = "bg-glass",
    variant = "classic",
  } = props;

  const tabIdFromLocalStorage = tabIdKey
    ? localStorage.getItem(tabIdKey)
    : null;
  const initialTabId = tabIdFromLocalStorage || tabsList[0]?.id;
  const [activeTabId, setActiveTabId] = useState(initialTabId);

  const handleTabChange = (tabId) => {
    if (activeTabId !== tabId) {
      if (tabIdKey) {
        localStorage.setItem(tabIdKey, tabId);
      }
      setActiveTabId(tabId);
      if (onClick) {
        onClick(tabId);
      }
    }
  };

  const getBadgePositionClass = () => {
    switch (badgePosition) {
      case "top-start":
        return "translate-middle-x translate-middle-y start-0";
      case "top-end":
        return "translate-middle-x translate-middle-y end-0";
      default:
        return "ms-2";
    }
  };

  const getCountBadgeTypeClass = (tab) => {
    switch (tab.countBadgeType) {
      case "danger":
        return "bg-danger-subtle text-danger";
      case "success":
        return "bg-success-subtle text-success";
      case "warning":
        return "bg-warning-subtle text-warning";
      case "primary":
        return "bg-primary-subtle text-primary";
      default:
        return "bg-light text-dark";
    }
  };

  if (variant === "underline") {
    return (
      <div
        className="position-sticky top-0 w-100 bg-transparent"
        style={{ overflowX: "auto", zIndex: 5 }}
      >
        <div className="btb-underline d-flex gap-4 flex-nowrap mt-2">
          {tabsList.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`btb-underline-tab ${activeTabId === tab.id ? "active" : ""}`}
              onClick={() => handleTabChange(tab.id)}
            >
              {tab.name}
              {(showCountOnlyOnActiveTab ? activeTabId === tab.id : true) &&
              tabsCount?.[tab.id] > 0 ? (
                <span
                  className={`badge fw-bold ms-2 ${getCountBadgeTypeClass(tab)}`}
                >
                  {tabsCount?.[tab.id]}
                </span>
              ) : null}
            </button>
          ))}
        </div>
        <style>{UNDERLINE_TAB_CSS}</style>
      </div>
    );
  }

  return (
    <div
      className=" position-sticky top-0 w-100 bg-transparent"
      style={{ overflowX: "auto", zIndex: 5 }}
    >
      <div
        className={` ${tabBarBgColor} d-flex gap-1 justify-content-start align-items-center m-0 p-1 mt-2 rounded-2 flex-nowrap`}
      >
        {tabsList.map((tab) => (
          <div
            key={tab.id}
            className={` d-flex align-items-center text-nowrap cursor-pointer position-relative px-3 ${
              activeTabId === tab.id
                ? tab.activeClassName ||
                  "bg-white rounded-2 shadow-sm fw-semibold"
                : " opacity-75"
            }`}
            onClick={() => handleTabChange(tab.id)}
          >
            <span>{tab.name}</span>
            {(showCountOnlyOnActiveTab ? activeTabId === tab.id : true) &&
            tabsCount?.[tab.id] > 0 ? (
              <span
                className={` badge fw-bold ${getCountBadgeTypeClass(
                  tab
                )} ${getBadgePositionClass()}`}
              >
                {tabsCount?.[tab.id]}
              </span>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
}

const UNDERLINE_TAB_CSS = `
.btb-underline {
  border-bottom: 1px solid #E5E7EB;
  background: rgba(248, 255, 253, 0.8);
  backdrop-filter: blur(5px);
}
.btb-underline-tab {
  background: none;
  border: none;
  padding: 8px 2px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #6B7280;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  transition: color 0.15s ease;
}
.btb-underline-tab:hover { color: #111827; }
.btb-underline-tab:focus-visible { outline: 2px solid #2563EB; outline-offset: 2px; border-radius: 4px; }
.btb-underline-tab::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: transparent;
  border-radius: 2px 2px 0 0;
  transform: scaleX(0.85);
  transition: background 0.15s ease, transform 0.15s ease;
}
.btb-underline-tab.active {
  color: #111827;
  font-weight: 600;
}
.btb-underline-tab.active::after {
  background: #2563EB;
  transform: scaleX(1);
}
`;

export default ButtonTabBar;
